// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__30ABC","spin":"loader_spin__2-JGt"};